import { tagsContract } from './tags.contract';
import { gatewayContract } from './gateway.contract';
import { mergedTagsContract } from './mergedTags.contract';
import { staticTagsContract } from './staticTags.contract';
import { staticAnchorsContract } from './staticAnchors.contract';
import { staticEquipmentContract } from './staticEquipment.contract';
import { staticAdminContract, adminPanelStreamRoute } from './staticAdmin.contract';

export { tagsContract } from './tags.contract';
export { gatewayContract } from './gateway.contract';
export { mergedTagsContract } from './mergedTags.contract';
export { staticTagsContract } from './staticTags.contract';
export { staticAnchorsContract } from './staticAnchors.contract';
export { staticEquipmentContract } from './staticEquipment.contract';
export { staticAdminContract, adminPanelStreamRoute } from './staticAdmin.contract';

export const siteNetIntegratorContracts = {
	tagsContract,
	gatewayContract,
	mergedTagsContract,
	staticTagsContract,
	staticAnchorsContract,
	staticEquipmentContract,
	staticAdminContract,
};
